import { render, staticRenderFns } from "./PrivilegeSafetyConfirmation.vue?vue&type=template&id=3dfc2196"
import script from "./PrivilegeSafetyConfirmation.vue?vue&type=script&lang=js"
export * from "./PrivilegeSafetyConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports